export default __webpack_public_path__ + "locales/tr/Ldap.json?hash=45c089530e316759183ee73869679cc7";